module.exports = __webpack_public_path__ + "static/media/left-chatbot-arrow.8b360af2.svg";